import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { PlanAniosService } from '../../services/plan-anios.service';
import { IpPublicService } from 'src/app/services/ip-public.service';
import { AlertService } from 'src/app/services/alert.service';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { ModalService } from 'src/app/services/modal.service';
import { DataTableDirective } from 'angular-datatables';
import { Subject, forkJoin, map } from 'rxjs';
import { PlanInstitucionalService } from '../../services/plan-institucional.service';
import { PlanesInstitucionalesAnualesService } from '../../services/planes-institucionales-anuales.service';
import { AniosObjetivosService } from '../../services/anios-objetivos.service';
import { AniosService } from '../../services/anios.service';
import { DatePipe } from '@angular/common';
import { ConstantsCatalogosIdService } from 'src/app/services/constants-catalogos-id.service';

@Component({
  selector: 'app-plan-anios',
  templateUrl: './plan-anios.component.html',
  styleUrls: ['./plan-anios.component.css'],
})
export class PlanAniosComponent implements OnInit, OnDestroy{
  breadCrumbItems = [
    { label: 'Administración Procesos' },
    { label: 'Gestión Planes' },
    { label: 'Plan Años', active: true },
  ];

  public mostrarModal: boolean = false;
  public dataCatalogoAnios: any = [];
  public fechaAnio: any = [];
  public formSubmitted = false;
  public formAnios!: FormGroup;
  public dataPlanIns!: any;
  public dataAnios: any = [];
  public dataAniosPlanes: any = [];
  public dataDrive2;
  public dataPlanesInst: any = [];
  public dataPlanesInstActivos: any = [];
  public dataEstadoPlanesInstActivos: any = [];
  public dataPlanesAniosInactivos: any = [];
  public dataPlanInsitucionalSelect: any = [];
  public dataPlanAnios: any = [];
  public dataAniosFechas: any = [];
  public dataAniosPlanInst: any = [];
  public idSprUsuario: any;
  public ipAddress!: string;
  public dataAniosSelect: any = [];
  public anio: any;
  public vectorAnio: any = [];
  public selectPlan: number = 0;
  public anioInicio!: number;
  public anioFin!: number;
  public fecha: string = '2022-01-01';
  public fechaInicioNuevo: any;
  public fechaFinNuevo: any;
  public formatoFechasInicio = null;
  public formatoFechasFin = null;
  public numeroFechas = null;
  public update: any;
  public idSprAmbiente: any;
  public currentAmbiente: any;
  filtroPost = '';
  descriptionApp = localStorage.getItem('descriptionApp');
  buffer!: any;
  currentUser!: any;
  private idDeleteRegister: number = 0;
  public nameModal: string = 'modalNewEdit';
  public nameApp = 'Plan Años';
  namePlanAnios = 'PLAN AÑOS';
  isSubmitted = false;
  public estadoActivo: number = 1;
  public estadoInactivo: number = 2;
  public retornaValorFechaInicio: number;
  public retornaValorFechaFin: number;
  public fechaInicioDate: any;
  public fechaFinDate: any;
  pipe = new DatePipe('en-US');
  public dataCompararFechas: boolean;
  public dataCompararFechasFin: boolean;
  public dataPlanInstitucional: any = [];

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  isDtInitialized: boolean = false;

  readonly constant = ConstantsCatalogosIdService;

  constructor(
    private fb: FormBuilder,
    private catalogoAniosService: PlanAniosService,
    private planInstitucionalAnios: PlanesInstitucionalesAnualesService,
    private planesAniosService: AniosObjetivosService,
    private ip: IpPublicService,
    private alert: AlertService,
    public modal: ModalService,
    private planInstitucionalService: PlanInstitucionalService,
    private cdRef: ChangeDetectorRef,

    private planAniosService: PlanAniosService,
    public aniosService: AniosService,
    private planInstitucionalAniosService: PlanInstitucionalService //private planesAniosService: AniosObjetivosService
  ) {
    this.buffer = localStorage.getItem('currentUser');
    this.currentUser = JSON.parse(this.buffer);
    this.idSprAmbiente = this.currentUser.idSprAmbiente;
    this.currentAmbiente = JSON.parse(this.buffer);
  }

  ngOnInit() {
    this.getIpPublic();
    this.initApp();
  }

  ngAfterViewInit() {
    this.cdRef.detectChanges();
  }

  initApp() {
    this.setDataTable();
    this.setForm();
    //this.getPlanAnios();
    this.mapAniosPlanes();
    this.listPlanesActivos();
    this.lisDataPlanesAnios();
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

  setForm() {
    this.formAnios = this.fb.group({
      idSprPlanAnio: [],
      idSprAnio: [0],
      idSprPlanInstitucional: ['', [Validators.required]],
      //anio: ['', [Validators.required]],
      fechaInicio: ['', [Validators.required]],
      fechaFin: ['', [Validators.required]],
      vigencia: ['', [Validators.required]],
      estado: ['', [Validators.required]],
    });
  }

  reDrawDataTable() {
    // Redibujar la tabla al actualizar datos
    if (this.isDtInitialized) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } else {
      this.isDtInitialized = true;
      this.dtTrigger.next(null);
    }
  }

  setDataTable() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      destroy: true,
      language: {
        //url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
      },
    };
  }

  getIpPublic() {
    this.ip.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }

  mapAniosPlanes() {
    let dataDrive = [];

    for (let i = 0; i < this.dataPlanesInst.length; i++) {
      for (let j = 0; j < this.dataPlanAnios.length; j++) {
        if (
          this.dataPlanesInst[i].idSprPlanInstitucional ==
          this.dataPlanAnios[j].idSprPlanInstitucional
        ) {
          for (let k = 0; k < this.dataAnios.length; k++) {
            if (
              this.dataAnios[k].idSprAnio == this.dataPlanAnios[j].idSprAnio
            ) {
              dataDrive.push({
                idSprPlanAnio: this.dataPlanAnios[j].idSprPlanAnio,
                idSprAnio: this.dataPlanAnios[j].idSprAnio,
                idSprPlanInstitucional:
                  this.dataPlanAnios[j].idSprPlanInstitucional,
                anio: this.dataAnios[k].anio,
                estado: this.dataPlanAnios[j].estado,
                nombrePlan: this.dataPlanesInst[i].nombre,
                fechaInicio: this.dataPlanAnios[j].fechaInicio,
                fechaFin: this.dataPlanAnios[j].fechaFin,
                vigencia: this.dataPlanAnios[j].vigencia,
              });
            }
          }
        }
      }
    }
    this.dataAniosPlanInst = dataDrive;
    //this.reDrawDataTable();
  }
  listPlanesActivos() {
    this.planInstitucionalAniosService
      .list(`?estado=` + this.estadoActivo)
      .subscribe({
        next: (resp) => {
          this.dataPlanesInstActivos = resp;

          this.update = 0;
        },
      });
  }

  listEstadoPlanesActivos(idSprPlanInstitucional: number) {
    this.planInstitucionalAniosService
      .list(`${idSprPlanInstitucional}`)
      .subscribe({
        next: (resp) => {
          this.dataEstadoPlanesInstActivos = resp;

          // if(this.dataEstadoPlanesInstActivos.estado==this.estadoInactivo){
          //   this.alert.warning(
          //     'Atención',
          //     'No se puede activar el plan años,!Primero debe activar el plan institucional al que pertence!'
          //   );
          // } else {
          //   this.selectPlanAnio(obj.idSprPlanAnio, dataPlanIns);
          //   this.openModal();
          //   this.formAnios.patchValue({
          //     idSprPlanAnio: obj.idSprPlanAnio,
          //     idSprAnio: obj.idSprAnio,
          //     idSprPlanInstitucional: obj.idSprPlanInstitucional,
          //     //idSprAnio: obj.anio,
          //     anio: obj.anio,
          //     fechaInicio: obj.fechaInicio,
          //     fechaFin: obj.fechaFin,
          //     vigencia: obj.vigencia,
          //     estado: obj.estado,
          //   });

          // }
        },
      });
  }
  findAniosPlanes(event: any, dataPlanesInst) {
    let anios: number;
    let fechaInicio: Date;
    let fechaFin: Date;
    anios = parseInt(event.target.value);
    let planInstitu = dataPlanesInst.filter((plan: any) => {
      return +plan.idSprPlanInstitucional === +anios;
    });
    this.aniosService.list().subscribe({
      next: (resp) => {
        this.dataAnios = resp;
      },
    });
    fechaInicio = planInstitu[0].fechaInicio.slice(0, 4);
    fechaFin = planInstitu[0].fechaFin.slice(0, 4);
    this.vectorAnio = [];
    for (let i = 0; i < this.dataAnios.length; i++) {
      if (
        this.dataAnios[i].anio >= fechaInicio &&
        this.dataAnios[i].anio <= fechaFin
      ) {
        this.vectorAnio.push(this.dataAnios[i]);
      }
    }
    this.formAnios.patchValue({
      idSprAnio: '',
      fechaInicio: '',
      fechaFin: '',
    });
  }
  findAnioFechas(event: any) {
    let anios2: [];
    let anios: number;
    anios = parseInt(event.target.value);
    this.aniosService.list(`${anios}`).subscribe((resp) => {
      this.dataAniosFechas = resp;
      anios2 = this.dataAniosFechas;
      this.formAnios.patchValue({
        fechaInicio: this.dataAniosFechas.fechaInicio,
        fechaFin: this.dataAniosFechas.fechaFin,
      });
    });
  }

  createFechaInicioFin(e: any) {
    ///aqui debo traer  el plan institucional con las fechas , pasar por parametro y con eso comparar las fechas para que se ponga automatoicamente
    let planIntitucional: any;
    const nuevaFecha = new Date();
    let anioInicio: any;
    let anioFin: any;
    let anioFechaInicio: any;
    let anioFechaFin: any;
    let anios: number;
    anios = parseInt(e.target.value);
   

    planIntitucional = this.formAnios.value.idSprPlanInstitucional;
    this.planInstitucionalService.list(`${planIntitucional}`).subscribe({
      next: (resp) => {
        this.dataPlanInsitucionalSelect = resp;
        anioFechaInicio = this.dataPlanInsitucionalSelect.fechaInicio;
        anioFechaFin = this.dataPlanInsitucionalSelect.fechaFin;
        anioInicio = this.dataPlanInsitucionalSelect.fechaInicio.slice(0, 4);
        anioFin = this.dataPlanInsitucionalSelect.fechaFin.slice(0, 4);
    
        this.aniosService.list(`${anios}`).subscribe({
          next: (resp) => {
            this.dataAniosFechas = resp;
            this.anio = this.dataAniosFechas.anio;
           
            // nuevaFecha.setFullYear(this.anio);
            // nuevaFecha.setMonth(0);
            // nuevaFecha.setDate(1);

            if (this.anio == anioInicio) {
             
              if (this.anio == anioInicio) {
               
                this.formAnios.patchValue({
                  fechaInicio: anioFechaInicio,
                });
                nuevaFecha.setFullYear(this.anio);
                nuevaFecha.setMonth(11);
                nuevaFecha.setDate(31);
                this.formAnios.patchValue({
                  fechaFin: nuevaFecha.toISOString().slice(0, 10),
                });
              }
            } else if (this.anio == anioFin) {
            
              if (this.anio == anioFin) {
                
                nuevaFecha.setFullYear(this.anio);
                nuevaFecha.setMonth(0);
                nuevaFecha.setDate(1);
                this.formAnios.patchValue({
                  fechaInicio: nuevaFecha.toISOString().slice(0, 10),
                });
                this.formAnios.patchValue({
                  fechaFin: anioFechaFin,
                });
              }
            } else {
              
              nuevaFecha.setFullYear(this.anio);
              nuevaFecha.setMonth(0);
              nuevaFecha.setDate(1);
              this.formAnios.patchValue({
                fechaInicio: nuevaFecha.toISOString().slice(0, 10),
              });
              nuevaFecha.setMonth(11);
              nuevaFecha.setDate(31);
              this.formAnios.patchValue({
                fechaFin: nuevaFecha.toISOString().slice(0, 10),
              });
            }

            this.fechaInicioDate = this.formAnios.value.fechaInicio;

            this.fechaFinDate = this.formAnios.value.fechaFin;
          },
        });
      },
    });
  }

  selectPlanAnio(event: any, dataPlanIns: any[]) {
    let planInstitu = dataPlanIns.filter((plan: any) => {
      return +plan.idSprPlanAnio === +event;
    });

    this.vectorAnio = planInstitu;
  }
  validacionFechas(fechaInicio: Date, fechaFin: Date) {
    let alerta1;
    if (fechaInicio < this.fechaInicioDate || fechaInicio > this.fechaFinDate) {
      alerta1 = this.alert.warning('¡Atención!','La fecha inicial debe estar dentro del periodo seleccionado.'
      );
    }
    if (fechaFin < this.fechaInicioDate || fechaFin > this.fechaFinDate) {
      alerta1 = this.alert.warning(
        '¡Atención!','La fecha Fin debe estar dentro del periodo seleccionado.'
      );
    }

    if (fechaInicio > fechaFin) {
      alerta1 = this.alert.fechaError();
    }
  }

  controlFechaInicio(event: any) {
    let alerta1;
    const nuevaFecha = new Date();
    let anioCapturado: number;
    let fechaComparar: Date;
    let fechaCompararFin: Date;
    let formatoFechasInicio = null;
    let formatoFechasFin = null;
    fechaComparar = event.target.value;
    anioCapturado = this.formAnios.value.idSprAnio;
    this.controlGuardarFechaInicio(fechaComparar);
    //this.controlFechaInicioNo(this.formAnios.value.idSprPlanInstitucional,this.formAnios.value.idSprAnio,this.formAnios.value.fechaInicio,this.formAnios.value.fechafin)
    this.aniosService.list(`${anioCapturado}` ).subscribe({
      next: (resp) => {
        this.dataAniosFechas = resp;
        this.anio = this.dataAniosFechas.anio;
        nuevaFecha.setFullYear(this.anio);
        nuevaFecha.setMonth(0);
        nuevaFecha.setDate(1);
        (this.fechaInicioNuevo = nuevaFecha.toISOString().slice(0, 10)),
          nuevaFecha.setMonth(11);
        nuevaFecha.setDate(31);
        this.fechaFinNuevo = nuevaFecha.toISOString().slice(0, 10);
        formatoFechasInicio = this.pipe.transform(
          this.fechaInicioNuevo,
          'dd/MM/yyyy'
        );

        formatoFechasFin = this.pipe.transform(
          this.fechaFinNuevo,
          'dd/MM/yyyy'
        );
        fechaCompararFin = this.formAnios.value.fechaFin;

        if (
          fechaComparar < this.fechaInicioNuevo ||
          fechaComparar > this.fechaFinNuevo
        ) {
          alerta1 = this.alert.warning(
            '¡Atención!',
            'La fecha inicio debe estar dentro del periodo de: ' +
              ' ' +
              formatoFechasInicio +
              ' ' +
              'hasta' +
              ' ' +
              formatoFechasFin
          );
        }
        if (fechaComparar > fechaCompararFin) {
          alerta1 = this.alert.fechaError();
        }
      },
    });
  }
  controlGuardarFechaInicio(event: any) {
    const nuevaFecha = new Date();
    let anioCapturado: number;
    let fechaComparar: Date;
    let fechaCompararFin: Date;

    fechaComparar = event;

    anioCapturado = this.formAnios.value.idSprAnio;

    this.aniosService.list(`${anioCapturado}`).subscribe({
      next: (resp) => {
        this.dataAniosFechas = resp;
        this.anio = this.dataAniosFechas.anio;
        nuevaFecha.setFullYear(this.anio);
        nuevaFecha.setMonth(0);
        nuevaFecha.setDate(1);
        (this.fechaInicioNuevo = nuevaFecha.toISOString().slice(0, 10)),
          nuevaFecha.setMonth(11);
        nuevaFecha.setDate(31);
        this.fechaFinNuevo = nuevaFecha.toISOString().slice(0, 10);
        this.formatoFechasInicio = this.pipe.transform(
          this.fechaInicioNuevo,
          'dd/MM/yyyy'
        );

        this.formatoFechasFin = this.pipe.transform(
          this.fechaFinNuevo,
          'dd/MM/yyyy'
        );
        fechaCompararFin = this.formAnios.value.fechaFin;
        if (
          fechaComparar < this.fechaInicioNuevo ||
          fechaComparar > this.fechaFinNuevo
        ) {
          this.retornaValorFechaFin = 1;
        } else if (fechaComparar > fechaCompararFin) {
          this.retornaValorFechaFin = 2;
        } else {
          this.retornaValorFechaFin = 0;
        }
        this.numeroFechas = this.retornaValorFechaFin;
      },
    });
  }
  controlFechaFin(event: any) {
    let alerta1;
    const nuevaFecha = new Date();
    let anioCapturado: number;
    let fechaComparar: Date;
    let fechaCompararInicio: Date;
    //let formatoFechasInicio = null;
    //let formatoFechasFin = null;
    fechaComparar = event.target.value;
    anioCapturado = this.formAnios.value.idSprAnio;
    this.controlGuardarFechaFin(fechaComparar);
    //anioPlanInstitucional, anio, fechaInicio,fechafin
    //this.controlFechaFinNO(this.formAnios.value.idSprPlanInstitucional,this.formAnios.value.idSprAnio,this.formAnios.value.fechaInicio,this.formAnios.value.fechafin)
    this.aniosService.list(`${anioCapturado}` ).subscribe({
      next: (resp) => {
        this.dataAniosFechas = resp;
        this.anio = this.dataAniosFechas.anio;
        nuevaFecha.setFullYear(this.anio);
        nuevaFecha.setMonth(0);
        nuevaFecha.setDate(1);
        (this.fechaInicioNuevo = nuevaFecha.toISOString().slice(0, 10)),
          nuevaFecha.setMonth(11);
        nuevaFecha.setDate(31);
        this.fechaFinNuevo = nuevaFecha.toISOString().slice(0, 10);
        this.formatoFechasInicio = this.pipe.transform(
          this.fechaInicioNuevo,
          'dd/MM/yyyy'
        );

        this.formatoFechasFin = this.pipe.transform(
          this.fechaFinNuevo,
          'dd/MM/yyyy'
        );
        fechaCompararInicio = this.formAnios.value.fechaInicio;
        if (
          fechaComparar < this.fechaInicioNuevo ||
          fechaComparar > this.fechaFinNuevo
        ) {
          alerta1 = this.alert.warning(
            '¡Atención!',
            'La fecha fin debe estar dentro del periodo de: ' +
              ' ' +
              this.formatoFechasInicio +
              ' ' +
              'hasta' +
              ' ' +
              this.formatoFechasFin
          );
        }
        if (fechaComparar < fechaCompararInicio) {
          alerta1 = this.alert.warning(
            '¡Atención!','La fecha fin no puede ser menor a la fecha inicio'
          );
        }
      },
    });
  }
  controlGuardarFechaFin(fechaFin: any) {
    let alerta1;
    const nuevaFecha = new Date();
    let anioCapturado: number;
    let compararFechaInicio: Date;
    let compararFechaFin: Date;
    let fechaCompararInicio: Date;

    compararFechaFin = fechaFin;
    anioCapturado = this.formAnios.value.idSprAnio;

    this.aniosService.list(`${anioCapturado}`).subscribe({
      next: (resp) => {
        this.dataAniosFechas = resp;
        this.anio = this.dataAniosFechas.anio;
        nuevaFecha.setFullYear(this.anio);
        nuevaFecha.setMonth(0);
        nuevaFecha.setDate(1);
        (this.fechaInicioNuevo = nuevaFecha.toISOString().slice(0, 10)),
          nuevaFecha.setMonth(11);
        nuevaFecha.setDate(31);
        this.fechaFinNuevo = nuevaFecha.toISOString().slice(0, 10);
        this.formatoFechasInicio = this.pipe.transform(
          this.fechaInicioNuevo,
          'dd/MM/yyyy'
        );

        this.formatoFechasFin = this.pipe.transform(
          this.fechaFinNuevo,
          'dd/MM/yyyy'
        );
        fechaCompararInicio = this.formAnios.value.fechaInicio;

        if (
          compararFechaFin < this.fechaInicioNuevo ||
          compararFechaFin > this.fechaFinNuevo
        ) {
          this.retornaValorFechaFin = 3;
        } else if (compararFechaFin < fechaCompararInicio) {
          this.retornaValorFechaFin = 4;
        } else {
          this.retornaValorFechaFin = 0;
        }
        this.numeroFechas = this.retornaValorFechaFin;
      },
    });
  }
  controlFechaInicioFin(anioPlanInstitucional, anio, fechaInicio, fechafin) {
    //esta funcion controla que las fechas de inicio y fin esten dentro del rango de fechas del plan institucional
    let anioInicioSelect;
    let anioFinSelect;
    let planAnioFechaInicio;
    let planAnioFechaFin;

    this.planInstitucionalService.list(`${anioPlanInstitucional}`).subscribe({
      next: (respPlanInstitucional) => {

        this.dataPlanInstitucional = respPlanInstitucional;
        this.aniosService.list(`${anio}`).subscribe({
          next: (resp) => {
            this.dataAniosSelect = resp;

            anioInicioSelect = this.dataPlanInstitucional.fechaInicio;
            anioInicioSelect = anioInicioSelect.slice(0, 4);

            anioFinSelect = this.dataPlanInstitucional.fechaFin;
            anioFinSelect = anioFinSelect.slice(0, 4);

            planAnioFechaInicio = this.dataPlanInstitucional.fechaInicio;
            planAnioFechaFin = this.dataPlanInstitucional.fechaFin;

            this.dataCompararFechas = false;
            if (anioInicioSelect == this.dataAniosSelect.anio) {
              if (fechaInicio >= planAnioFechaInicio) {
                this.dataCompararFechas = true;
              }
            } else if (anioFinSelect == this.dataAniosSelect.anio) {
              if (fechafin <= planAnioFechaFin) {
                this.dataCompararFechas = true;
              }
            } else if (
              this.dataAniosSelect.anio > anioInicioSelect &&
              this.dataAniosSelect.anio < anioFinSelect
            ) {
              this.dataCompararFechas = true;
            } else {
              this.dataCompararFechas = false;
            }
          },
        });
      },
    });
  }
  createPlanAnios() {
    let alerta1;
    let fechaInicio = this.formAnios.value.fechaInicio;
    let fechaFin = this.formAnios.value.fechaFin;
    let valorAnios: boolean;
    let anioInicioSelect;
    let anioFinSelect;
    let planAnioFechaInicio;
    let planAnioFechaFin;
    //this.validacionFechas(fechaInicio, fechaFin);
    this.formSubmitted = true;
    this.formAnios.value.usuario = this.currentUser.idSprUsuario;
    this.formAnios.value.ip = this.ipAddress;
    this.formAnios.value.idSprAmbiente = this.idSprAmbiente;
    //inico
    this.planInstitucionalService
      .list(`${this.formAnios.value.idSprPlanInstitucional}`)
      .subscribe({
        next: (respPlanInstitucional) => {
          this.dataPlanInstitucional = respPlanInstitucional;
          this.aniosService
            .list(`${this.formAnios.value.idSprAnio}`)
            .subscribe({
              next: (resp) => {
                this.dataAniosSelect = resp;

                anioInicioSelect = this.dataPlanInstitucional.fechaInicio;
                anioInicioSelect = anioInicioSelect.slice(0, 4);

                anioFinSelect = this.dataPlanInstitucional.fechaFin;
                anioFinSelect = anioFinSelect.slice(0, 4);

                planAnioFechaInicio = this.dataPlanInstitucional.fechaInicio;
                planAnioFechaFin = this.dataPlanInstitucional.fechaFin;
                this.dataCompararFechas = false;
                if (anioInicioSelect == this.dataAniosSelect.anio) {
                  if (fechaInicio >= planAnioFechaInicio) {
                    this.dataCompararFechas = true;
                  }
                } else if (anioFinSelect == this.dataAniosSelect.anio) {
                  if (fechaFin <= planAnioFechaFin) {
                    this.dataCompararFechas = true;
                  }
                } else if (
                  this.dataAniosSelect.anio > anioInicioSelect &&
                  this.dataAniosSelect.anio < anioFinSelect
                ) {
                  this.dataCompararFechas = true;
                } else {
                  this.dataCompararFechas = false;
                }


                //inicio

                if (this.numeroFechas == 1) {
                  alerta1 = this.alert.warning(
                    '¡Atención!',
                    'La fecha inicio debe estar dentro del periodo de: ' +
                      ' ' +
                      this.formatoFechasInicio +
                      ' ' +
                      'hasta' +
                      ' ' +
                      this.formatoFechasFin
                  );
                } else if (this.numeroFechas == 2) {
                  alerta1 = this.alert.warning(
                    '¡Atención!',
                    'La fecha inicio no puede ser mayor a la fecha fin.'
                  );
                } else if (this.numeroFechas == 3) {
                  alerta1 = this.alert.warning(
                    '¡Atención!',
                    'La fecha fin debe estar dentro del periodo de: ' +
                      ' ' +
                      this.formatoFechasInicio +
                      ' ' +
                      'hasta' +
                      ' ' +
                      this.formatoFechasFin
                  );
                } else if (this.numeroFechas == 4) {
                  alerta1 = this.alert.warning(
                    '¡Atención!',
                    'La fecha fin no puede ser menor  a la fecha inicio.'
                  );
                } else if (this.dataCompararFechas == false) {
                  alerta1 = this.alert.warning(
                    '¡Atención!',
                    'La Fecha Inicio  del Plan Año no puede estar fuera  del rango  del  Plan Institucional.'
                  );
                } else {
                  //control de fechas

                  if (
                    this.formAnios.value.idSprPlanAnio == null ||
                    this.formAnios.value.idSprPlanAnio == ''
                  ) {
                    this.formAnios.value.delLog = 'N';
                    this.planesAniosService
                      .create(this.formAnios.value)
                      .subscribe(
                        (resp) => {
                          this.closeModal();
                          // this.getPlanAnios();
                          this.lisDataPlanesAnios();
                          this.alert.createOk();
                        },
                        (err) => {
                          // this.alert.createError('Ocurrrió un error al crear el registro');
                          //  this.catalogoAniosService.delete(this.formAnios.value).subscribe();
                        }
                      );
                  } else {
                    this.planesAniosService
                      .update(this.formAnios.value)
                      .subscribe(
                        (resp) => {
                          this.closeModal();
                          //this.getPlanAnios();
                          this.lisDataPlanesAnios();
                          this.alert.updateOk();
                        },
                        (err) => {
                          this.alert.updateError();
                        }
                      );
                  }

                  //fin control de fechas
                }
                //fin
              },
            });
        },
      });
    //fin

    return false;
  }

  updatePlanAnios(obj: any, dataPlanIns: any[]) {
    this.planInstitucionalAniosService
      .list(`${obj.idSprPlanInstitucional}`)
      .subscribe({
        next: (resp) => {
          this.dataEstadoPlanesInstActivos = resp;

          if (this.dataEstadoPlanesInstActivos.estado == this.estadoInactivo) {
            this.alert.warning('¡Atención!','No se puede activar el plan años, primero debe activar el Plan Institucional al que pertence.'
            );
          } else {
            this.selectPlanAnio(obj.idSprPlanAnio, dataPlanIns);
            this.openModal();
            this.formAnios.patchValue({
              idSprPlanAnio: obj.idSprPlanAnio,
              idSprAnio: obj.idSprAnio,
              idSprPlanInstitucional: obj.idSprPlanInstitucional,
              //idSprAnio: obj.anio,
              anio: obj.anio,
              fechaInicio: obj.fechaInicio,
              fechaFin: obj.fechaFin,
              vigencia: obj.vigencia,
              estado: obj.estado,
            });
          }
        },
      });
  }

  lisDataPlanesAnios() {
    forkJoin([
      this.aniosService.list(),
      this.planInstitucionalAniosService.list(),
      this.planesAniosService.list(),
    ])
      .pipe(
        map(([anios, planInstitucional, planAnios]) => {
          this.dataAnios = anios;
          this.dataPlanesInst = planInstitucional;
          this.dataPlanAnios = planAnios;

          this.mapearDataAniosPlanes();
        })
      )
      .subscribe();
  }

  mapearDataAniosPlanes() {
    let dataDrive = [];
    for (let i = 0; i < this.dataPlanesInst.length; i++) {
      for (let j = 0; j < this.dataPlanAnios.length; j++) {
        if (
          this.dataPlanesInst[i].idSprPlanInstitucional ==
          this.dataPlanAnios[j].idSprPlanInstitucional
        ) {
          for (let k = 0; k < this.dataAnios.length; k++) {
            if (
              this.dataAnios[k].idSprAnio == this.dataPlanAnios[j].idSprAnio
            ) {
              dataDrive.push({
                idSprPlanAnio: this.dataPlanAnios[j].idSprPlanAnio,
                idSprAnio: this.dataPlanAnios[j].idSprAnio,
                idSprPlanInstitucional:
                  this.dataPlanAnios[j].idSprPlanInstitucional,
                anio: this.dataAnios[k].anio,
                estado: this.dataPlanAnios[j].estado,
                nombrePlan: this.dataPlanesInst[i].nombre,
                fechaInicio: this.dataPlanAnios[j].fechaInicio,
                fechaFin: this.dataPlanAnios[j].fechaFin,
                vigencia: this.dataPlanAnios[j].vigencia,
              });
            }
          }
        }
      }
    }
    this.dataAniosPlanInst = dataDrive;
    this.reDrawDataTable();
  }

  // selectAniosPlanes(event: any, dataPlanIns: any[])
  // {
  //   let planInstitu = dataPlanIns.filter((plan: any) => {
  //     return +plan.idSprPlanInstitucional === +event;
  //   });

  // }

  // getPlanAnios() {
  //   this.catalogoAniosService
  //     .list(`?idSprAmbiente=` + this.idSprAmbiente)
  //     .subscribe((resp) => {
  //       this.dataCatalogoAnios = resp;
  //       this.getDataPlanIns();
  //     });
  // }

  getAnios(anio: number) {
    let numeroanio: number;
    numeroanio = anio;
    let dataDrive1 = [];

    this.aniosService.list().subscribe((resp) => {
      this.fechaAnio = resp;
    });

    for (let j = 0; j < this.fechaAnio.length; j++) {
      if (this.fechaAnio[j].idSprAnio == numeroanio) {
        dataDrive1.push({
          anio: this.dataAnios[j].anio,
        });
      }
    }
    this.dataDrive2 = dataDrive1;
  }

  getDataPlanIns() {
    this.catalogoAniosService
      .getDataPlanIns(`?estado=` + this.estadoActivo)
      .subscribe((resp) => {
        // this.dataobjetivon1: se muestra en el formulario
        this.dataPlanIns = resp;
        //this.reDrawDataTable();
      });
  }

  selectAnioa(e) {
    let var1: number;
    // validadcion para que se seleccione automaticamente un año
    this.getAnios(e.target.value);
    const nuevaFecha = new Date();
    var1 = parseInt(this.dataDrive2[0].anio);
    nuevaFecha.setFullYear(var1);
    nuevaFecha.setMonth(0);
    nuevaFecha.setDate(1);

    this.formAnios.patchValue({
      fechaInicio: nuevaFecha.toISOString().slice(0, 10),
    });

    this.fechaInicioDate = this.formAnios.value.fechaInicio;

    nuevaFecha.setMonth(11);
    nuevaFecha.setDate(31);
    this.formAnios.patchValue({
      fechaFin: nuevaFecha.toISOString().slice(0, 10),
    });

    this.fechaFinDate = this.formAnios.value.fechaFin;
  }

  // Modal Crear/editar

  openModal() {
    this.onResetForm();
    this.modal.open(this.nameModal);
  }

  onResetForm() {
    this.formSubmitted = false;
    this.formAnios.reset();
  }

  closeModal() {
    this.modal.close();
  }

  verifyAño() {
    return this.planesAniosService
      .list(`?idSprAnio=${this.idDeleteRegister}&delLog=N`)
      .toPromise();
  }

  async confirmDelete() {
    let confirmDelete = true;
    let dataVerifyRelacion: any = [];
    //##############  verificacion1 si existe datos relacionado ########################
    dataVerifyRelacion = await this.verifyAño();
    dataVerifyRelacion.length > 0 ? (confirmDelete = false) : '';
    //###################################################################################

    if (confirmDelete) {
      this.catalogoAniosService
        .delete({
          idSprAnio: this.idDeleteRegister,
          usuario: this.currentUser.idSprUsuario,
          delLog: 'S',
          ip: this.ipAddress,
        })
        .subscribe(
          (resp) => {
            //this.getPlanAnios();
            this.lisDataPlanesAnios();
            this.alert.deleteOk();
            this.initApp();
            this.modal.closeId('deleteAnios');
          },
          (err) => {
            this.alert.deleteError();
          }
        );
    } else {
      this.alert.warning(
        '¡Atención!',
        'No se puede borrar, existe Objetivos relacionados.'
      );
    }
    this.modal.closeId('deleteAnios');
  }

  deletePlanAnios(idRegister: number) {
    this.modal.open('deleteAnios');
    this.idDeleteRegister = idRegister;
  }
}
